package gr.tech.util

/*
    General site wide valid values
*/
val validStates = listOf(
    "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
    "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
    "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
    "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
    "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
)

/*
    General validation functions for input fields.
 */
fun String.validateInput(minLength: Int = 6, maxLength: Int = 128): String {
    return if (this.length < minLength) "Must be at least $minLength characters"
    else if (this.length > maxLength) "Must be no longer than $maxLength characters"
    else if (this.isBlank()) "Must be at least $minLength characters"
    else ""
}

fun String.isValidInput(minLength: Int = 6, maxLength: Int = 128): Boolean {
    return this.length >= minLength && this.length <= maxLength && !this.isBlank()
}

fun Int?.validateInput(min: Int = 0, max: Int = 1000000): String {
    return when {
        this == null -> "Proper value must be provided"
        this < min -> "Value must be at least $min"
        this > max -> "Value must be no greater than $max"
        else -> ""
    }
}

fun Int?.isValidInput(min: Int = 0, max: Int = 1000000): Boolean {
    return this != null && this >= min && this <= max
}


fun Long.validateInput(min: Long = 0, max: Long = 1000000): String {
    return when {
        this < min -> "Value must be at least $min"
        this > max -> "Value must be no greater than $max"
        else -> ""
    }
}

// Used mainly for currency conversion
fun Long.validateCurrencyInput(min: Long = 0, max: Long = 1000000): String {
    return when {
        this < min -> "Value must be at least $${min/100}"
        this > max -> "Value must be no greater than $${max/100}"
        else -> ""
    }
}

fun checkValidSelectOption(input: String?, validList: List<String>): String {
    return if (input != null && validList.contains(input)) {
        input
    } else {
        validList.first()
    }
}

fun isValidSelectOption(input: String?, validList: List<String>): Boolean {
    return input != null && validList.contains(input)
}
